import { ComponentChildren, Fragment, h } from "preact"
import { SearchQuery } from "../../api"
import { useContext } from "preact/hooks"
import { Context } from "./Context"

export function HistoryElementProvider(props: {
    onHistorySubmit(query: SearchQuery): void
    children: ComponentChildren
}) {
    return <Context.Provider value={props.onHistorySubmit}>{props.children}</Context.Provider>
}

/**
 * @group Components
 */
export interface HistoryElementProps {
    children: ComponentChildren
    /**
     * Execute new search with specified query on the selection.
     */
    query?: SearchQuery
    /**
     * Append class to element.
     */
    class?: string
    /**
     * Append class when element is selected with keyboard.
     */
    activeClass?: string
}

/**
 * @group Components
 */
export function HistoryElement({ children, query, class: className }: HistoryElementProps) {
    const onSubmit = useContext(Context)

    return (
        <Fragment>
            <div
                className={`ns-autocomplete-element ${className || ""}`}
                data-nosto-query={query?.query}
                onClick={() => {
                    if (query) {
                        onSubmit(query)
                    }
                }}
                onKeyDown={event => {
                    if (event.key === "Enter" && query) {
                        onSubmit(query)
                    }
                }}
            >
                {children}
            </div>
        </Fragment>
    )
}
